import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddressPopupForm from './AddressPopupForm';

import { CardTypes } from '../../utils/enums';

import {
    onAddressSubmit,
    onPostalCodeChange
} from '../../containers/VoteRegistration/actions';

import {
    AnimationContainer,
    ContainerAbsolute,
    Body
} from '../../containers/DefaultStyles/AssessmentDetails';

import { cacheFormData } from '../../utils/formCaching/actions';

const AddressPopup = props => (
    <AnimationContainer>
        <ContainerAbsolute>
            <Body>
                <AddressPopupForm
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.onAddressSubmit(
                            props.apiRequestData,
                            values,
                            props.id,
                            props.state,
                            props.localRepLoaded,
                            props.isPostalCodeChanged,
                            props.actionIdentifier,
                            props.isMultiActionsCard
                        );
                    }}
                    onBack={props.onBack}
                    isAddressSubmitting={props.isAddressSubmitting}
                    month={props.month}
                    year={props.year}
                    day={props.day}
                    postalCode={props.postalCode}
                    onPostalCodeChange={props.onPostalCodeChange}
                    isErrorOnSubmit={props.isErrorOnSubmit}
                />
            </Body>
        </ContainerAbsolute>
    </AnimationContainer>
);

AddressPopup.propTypes = {
    onAddressSubmit: PropTypes.func.isRequired,
    isAddressSubmitting: PropTypes.bool,
    month: PropTypes.array,
    year: PropTypes.array,
    day: PropTypes.array,
    onBack: PropTypes.func,
    postalCode: PropTypes.string,
    id: PropTypes.number,
    state: PropTypes.string,
    apiRequestData: PropTypes.object.isRequired,
    localRepLoaded: PropTypes.bool,
    isPostalCodeChanged: PropTypes.bool,
    onPostalCodeChange: PropTypes.func,
    actionIdentifier: PropTypes.string.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    isErrorOnSubmit: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        let year = [];
        for (var i = 0; i < 100; i++) {
            year.push(new Date().getUTCFullYear() - i);
        }

        let day = [];
        for (i = 1; i <= 31; i++) {
            day.push(i);
        }

        return {
            isAddressSubmitting: state.voteRegistration.isAddressSubmitting,
            month: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            year,
            day,
            postalCode: state.localRep.localRepData.postalCode,
            id: state.widget.activeAction.id,
            state: state.localRep.localRepData.state,
            apiRequestData: state.widget.apiRequestData,
            localRepLoaded: state.localRep.localRepData.representative !== undefined,
            isPostalCodeChanged: state.voteRegistration.isPostalCodeChanged,
            actionIdentifier: state.widget.activeAction.identifier,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isErrorOnSubmit: state.voteRegistration.isErrorOnSubmit
        };
    },
    {
        onAddressSubmit,
        onPostalCodeChange,
        cacheFormData
    }
)(AddressPopup);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/AddressPopup.jsx